import { render, staticRenderFns } from "./SetDiscounts.vue?vue&type=template&id=bea807b4&scoped=true&"
import script from "./SetDiscounts.vue?vue&type=script&lang=js&"
export * from "./SetDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./SetDiscounts.vue?vue&type=style&index=0&id=bea807b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea807b4",
  null
  
)

export default component.exports